var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4975 3.09961C6.81163 3.09961 3 6.91231 3 11.5995C3 13.4584 3.59948 15.1824 4.61854 16.5817L3.55944 19.7397L6.82657 18.6955C8.17034 19.585 9.77394 20.0996 11.5025 20.0996C16.1884 20.0996 20 16.2868 20 11.5997C20 6.91246 16.1884 3.09975 11.5025 3.09975L11.4975 3.09961ZM9.12455 7.41719C8.95973 7.02245 8.83482 7.00751 8.58513 6.99736C8.50011 6.99242 8.40537 6.98749 8.30033 6.98749C7.97549 6.98749 7.63585 7.0824 7.431 7.29225C7.1813 7.54709 6.56179 8.14166 6.56179 9.36099C6.56179 10.5803 7.45101 11.7596 7.57086 11.9246C7.69577 12.0893 9.30444 14.6278 11.8022 15.6624C13.7555 16.4719 14.3351 16.3969 14.7796 16.302C15.429 16.1621 16.2434 15.6822 16.4482 15.1027C16.6531 14.5229 16.6531 14.0282 16.593 13.9233C16.5331 13.8183 16.3681 13.7585 16.1184 13.6335C15.8687 13.5085 14.6547 12.9088 14.4249 12.8289C14.2 12.744 13.9853 12.774 13.8155 13.0139C13.5757 13.3487 13.341 13.6886 13.1511 13.8934C13.0012 14.0533 12.7563 14.0733 12.5516 13.9883C12.2768 13.8735 11.5075 13.6034 10.5583 12.7589C9.82386 12.1044 9.32434 11.29 9.17954 11.0452C9.03461 10.7954 9.16458 10.6503 9.27935 10.5154C9.40426 10.3605 9.52412 10.2506 9.64903 10.1056C9.77395 9.96078 9.84388 9.88576 9.92382 9.71582C10.0088 9.55096 9.94877 9.38102 9.88885 9.25607C9.82893 9.13111 9.32941 7.91178 9.12455 7.41719Z",
    fill: "#67C15E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(3 3.09961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.5eb5760743b1e3885e82eeb4c8d9f5e3.svg";
export { ForwardRef as ReactComponent };